import React, { useMemo } from "react";
import { Clock } from "lucide-react";
import FilaZeroSelect from "./FilaZeroSelect";

const buildTimeOptions = ({ start = "06:00", end = "23:30", step = 30 }) => {
  const [startHour, startMinute] = start.split(":").map(Number);
  const [endHour, endMinute] = end.split(":").map(Number);
  const startTotal = startHour * 60 + startMinute;
  const endTotal = endHour * 60 + endMinute;
  const options = [];

  for (let total = startTotal; total <= endTotal; total += step) {
    const hour = String(Math.floor(total / 60)).padStart(2, "0");
    const minute = String(total % 60).padStart(2, "0");
    options.push({ value: `${hour}:${minute}`, label: `${hour}:${minute}` });
  }

  return options;
};

const FilaZeroTimeSelect = ({
  value,
  onChange,
  name,
  placeholder = "Selecione a hora",
  disabled = false,
  start = "06:00",
  end = "23:30",
  step = 30,
  error,
  className = "",
}) => {
  const options = useMemo(
    () => buildTimeOptions({ start, end, step }),
    [start, end, step]
  );

  return (
    <div
      className={`fz-time-select${error ? " input-error" : ""} ${className}`.trim()}
    >
      <FilaZeroSelect
        name={name}
        value={String(value || "").slice(0, 5)}
        options={options}
        onChange={onChange}
        placeholder={placeholder}
        isDisabled={disabled}
        isSearchable
        leadingIcon={<Clock size={17} />}
        maxMenuHeight={240}
      />
      {error && <div className="error-text">{error}</div>}
    </div>
  );
};

export default FilaZeroTimeSelect;
